import type { WhatsAppInboxChat } from '@zrsystem/contracts';

import {
  sumWhatsAppInboxUnreadCount,
  useWhatsAppInboxChatsForActivePlace,
} from '@/features/notification/hooks/use-whatsapp-inbox-chats.js';

export function resolveWhatsAppInboxUnreadCount(
  chats: readonly WhatsAppInboxChat[] | undefined,
): number {
  if (chats === undefined) {
    return 0;
  }
  return sumWhatsAppInboxUnreadCount(chats);
}

export function useWhatsAppInboxUnreadCount(): number {
  const chatsQuery = useWhatsAppInboxChatsForActivePlace();
  return resolveWhatsAppInboxUnreadCount(chatsQuery.data?.chats);
}
